/* AuditStatusRenderer.js */

"use strict";
const auditStatuses = require("../../deviceConstants").AUDIT_STATUSES;

class AuditStatusColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("audit-status-column");
        this._rootElem.component = this._model;

        this._auditStatuses = auditStatuses;
        this._statusIcon = document.createElement("base-icon-gl");

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._statusIcon.remove();
            this._statusIcon = undefined;
            this._auditStatuses = undefined;

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("AuditStatus", (this._onAuditStatus = this._onAuditStatus.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("AuditStatus");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        this._setAuditStatus(this._model.getAuditStatus());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onAuditStatus(newVal) {
        this._setAuditStatus(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setAuditStatus(newVal = "UNKNOWN") {
        const auditStatus = this._auditStatuses[newVal];
        if (auditStatus) {
            this._updateIcon(auditStatus);
            if (!this._rootElem.contains(this._statusIcon)) {
                this._rootElem.innerHTML = "";
                this._rootElem.appendChild(this._statusIcon);
            }
        } else {
            this._rootElem.innerHTML = newVal;
        }
    }

    _updateIcon({ icon = "", title = "", name = "" } = {}) {
        this._statusIcon.dataset.icon = icon;
        this._statusIcon.setAttribute("title", title);
        this._statusIcon.setInvalid(name === "ERROR");
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = AuditStatusColumnRenderer;
